export const footerMoreLinks = {
  'bh-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://bh.wingie.com/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://bh.wingie.com/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://bh.wingie.com/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://bh.wingie.com/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://bh.wingie.com/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://bh.wingie.com/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'bh-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://bh.wingie.com/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://bh.wingie.com/en/faq/',
          title: 'Frequently Asked Questions',
        },
        {
          href: 'https://bh.wingie.com/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://bh.wingie.com/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://bh.wingie.com/en/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://bh.wingie.com/en/awards/',
          title: 'Our Awards',
        },
      ],
    },
  ],
  'bh-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://bh.wingie.com/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://bh.wingie.com/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },
        {
          href: 'https://bh.wingie.com/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://bh.wingie.com/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://bh.wingie.com/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://bh.wingie.com/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'bh-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://bh.wingie.com/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://bh.wingie.com/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },
        {
          href: 'https://bh.wingie.com/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://bh.wingie.com/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://bh.wingie.com/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://bh.wingie.com/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'bh-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://bh.wingie.com/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://bh.wingie.com/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },
        {
          href: 'https://bh.wingie.com/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://bh.wingie.com/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://bh.wingie.com/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://bh.wingie.com/ru/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'bh-it': [
    {
      title: 'Di più',
      items: [
        { href: 'https://bh.wingie.com/it/contact/', title: 'Contatti' },
        // { href: 'https://bh.wingie.com/it/faq/', title: 'Domande frequenti' },
        { href: 'https://bh.wingie.com/it/about-us/', title: 'Chi siamo' },
        { href: 'https://bh.wingie.com/it/privacy/', title: 'Privacy' },
        { href: 'https://bh.wingie.com/it/terms-and-conditions/', title: 'Termini e condizioni' },
        { href: 'https://bh.wingie.com/it/awards/', title: 'I nostri premi' },
      ],
    },
  ],
  'bh-fr': [
    {
      title: 'Plus',
      items: [
        { href: 'https://bh.wingie.com/fr/contact/', title: 'Contact' },
        // { href: 'https://bh.wingie.com/fr/faq/', title: 'Questions fréquemment posées' },
        { href: 'https://bh.wingie.com/fr/about-us/', title: 'À propos de nous' },
        { href: 'https://bh.wingie.com/fr/privacy/', title: 'Confidentialité' },
        { href: 'https://bh.wingie.com/fr/terms-and-conditions/', title: 'Conditions générales' },
        { href: 'https://bh.wingie.com/fr/awards/', title: 'Nos prix' },
      ],
    },
  ],
  'bh-pt': [
    {
      title: 'Mais',
      items: [
        { href: 'https://bh.wingie.com/pt/contact/', title: 'Contacto' },
        // { href: 'https://bh.wingie.com/pt/faq/', title: 'Perguntas frequentes' },
        { href: 'https://bh.wingie.com/pt/about-us/', title: 'Sobre nós' },
        { href: 'https://bh.wingie.com/pt/privacy/', title: 'Privacidade' },
        { href: 'https://bh.wingie.com/pt/terms-and-conditions/', title: 'Termos e condições' },
        { href: 'https://bh.wingie.com/pt/awards/', title: 'Os nossos prémios' },
      ],
    },
  ],
  'bh-ro': [
    {
      title: 'Mai multe',
      items: [
        { href: 'https://bh.wingie.com/ro/contact/', title: 'Contact' },
        // { href: 'https://bh.wingie.com/ro/faq/', title: 'Întrebări frecvente' },
        { href: 'https://bh.wingie.com/ro/about-us/', title: 'Despre noi' },
        { href: 'https://bh.wingie.com/ro/privacy/', title: 'Confidențialitate' },
        { href: 'https://bh.wingie.com/ro/terms-and-conditions/', title: 'Termeni și condiții' },
        { href: 'https://bh.wingie.com/ro/awards/', title: 'Premiile noastre' },
      ],
    },
  ],
  'bh-pl': [
    {
      title: 'Więcej',
      items: [
        { href: 'https://bh.wingie.com/pl/contact/', title: 'Kontakt' },
        // { href: 'https://bh.wingie.com/pl/faq/', title: 'Często zadawane pytania' },
        { href: 'https://bh.wingie.com/pl/about-us/', title: 'O nas' },
        { href: 'https://bh.wingie.com/pl/privacy/', title: 'Prywatność' },
        { href: 'https://bh.wingie.com/pl/terms-and-conditions/', title: 'Regulamin' },
        { href: 'https://bh.wingie.com/pl/awards/', title: 'Nasze nagrody' },
      ],
    },
  ],
  'bh-lt': [
    {
      title: 'Daugiau',
      items: [
        { href: 'https://bh.wingie.com/lt/contact/', title: 'Kontaktai' },
        // { href: 'https://bh.wingie.com/lt/faq/', title: 'Dažnai užduodami klausimai' },
        { href: 'https://bh.wingie.com/lt/about-us/', title: 'Apie mus' },
        { href: 'https://bh.wingie.com/lt/privacy/', title: 'Privatumas' },
        { href: 'https://bh.wingie.com/lt/terms-and-conditions/', title: 'Taisyklės ir sąlygos' },
        { href: 'https://bh.wingie.com/lt/awards/', title: 'Mūsų apdovanojimai' },
      ],
    },
  ],
  'bh-uz': [
    {
      title: "Ko'proq",
      items: [
        { href: 'https://bh.wingie.com/uz/contact/', title: 'Aloqa' },
        // { href: 'https://bh.wingie.com/uz/faq/', title: 'Tez-tez beriladigan savollar' },
        { href: 'https://bh.wingie.com/uz/about-us/', title: 'Biz haqimizda' },
        { href: 'https://bh.wingie.com/uz/privacy/', title: 'Maxfiylik' },
        { href: 'https://bh.wingie.com/uz/terms-and-conditions/', title: 'Shartlar va qoidalar' },
        { href: 'https://bh.wingie.com/uz/awards/', title: 'Bizning mukofotlarimiz' },
      ],
    },
  ],
  'bh-sr': [
    {
      title: 'Više',
      items: [
        { href: 'https://bh.wingie.com/sr/contact/', title: 'Kontakt' },
        // { href: 'https://bh.wingie.com/sr/faq/', title: 'Često postavljana pitanja' },
        { href: 'https://bh.wingie.com/sr/about-us/', title: 'O nama' },
        { href: 'https://bh.wingie.com/sr/privacy/', title: 'Privatnost' },
        { href: 'https://bh.wingie.com/sr/terms-and-conditions/', title: 'Uslovi korišćenja' },
        { href: 'https://bh.wingie.com/sr/awards/', title: 'Naše nagrade' },
      ],
    },
  ],
  'bh-ky': [
    {
      title: 'Көбүрөөк',
      items: [
        { href: 'https://bh.wingie.com/ky/contact/', title: 'Байланыш' },
        // { href: 'https://bh.wingie.com/ky/faq/', title: 'Көп берилүүчү суроолор' },
        { href: 'https://bh.wingie.com/ky/about-us/', title: 'Биз жөнүндө' },
        { href: 'https://bh.wingie.com/ky/privacy/', title: 'Купуялык' },
        { href: 'https://bh.wingie.com/ky/terms-and-conditions/', title: 'Шарттар жана эрежелер' },
        { href: 'https://bh.wingie.com/ky/awards/', title: 'Биздин сыйлыктар' },
      ],
    },
  ],
  'bh-tg': [
    {
      title: 'Зиёда',
      items: [
        { href: 'https://bh.wingie.com/tg/contact/', title: 'Тамос' },
        // { href: 'https://bh.wingie.com/tg/faq/', title: 'Саволҳои тез-тез пурсидашуда' },
        { href: 'https://bh.wingie.com/tg/about-us/', title: 'Дар бораи мо' },
        { href: 'https://bh.wingie.com/tg/privacy/', title: 'Махфият' },
        { href: 'https://bh.wingie.com/tg/terms-and-conditions/', title: 'Шартҳо ва қоидаҳо' },
        { href: 'https://bh.wingie.com/tg/awards/', title: 'Мукофотҳои мо' },
      ],
    },
  ],
  'bh-kk': [
    {
      title: 'Көбірек',
      items: [
        { href: 'https://bh.wingie.com/kk/contact/', title: 'Байланыс' },
        // { href: 'https://bh.wingie.com/kk/faq/', title: 'Жиі қойылатын сұрақтар' },
        { href: 'https://bh.wingie.com/kk/about-us/', title: 'Біз туралы' },
        { href: 'https://bh.wingie.com/kk/privacy/', title: 'Құпиялылық' },
        { href: 'https://bh.wingie.com/kk/terms-and-conditions/', title: 'Шарттар мен ережелер' },
        { href: 'https://bh.wingie.com/kk/awards/', title: 'Біздің марапаттар' },
      ],
    },
  ],
  'bh-nl': [
    {
      title: 'Meer',
      items: [
        { href: 'https://bh.wingie.com/nl/contact/', title: 'Contact' },
        // { href: 'https://bh.wingie.com/nl/faq/', title: 'Veelgestelde vragen' },
        { href: 'https://bh.wingie.com/nl/about-us/', title: 'Over ons' },
        { href: 'https://bh.wingie.com/nl/privacy/', title: 'Privacy' },
        { href: 'https://bh.wingie.com/nl/terms-and-conditions/', title: 'Algemene voorwaarden' },
        { href: 'https://bh.wingie.com/nl/awards/', title: 'Onze onderscheidingen' },
      ],
    },
  ],
  'bh-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://bh.wingie.com/ja/contact/' },
        { title: 'よくある質問', href: 'https://bh.wingie.com/en/faq/' },
        { title: '会社概要', href: 'https://bh.wingie.com/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://bh.wingie.com/ja/privacy/' },
        { title: '利用規約', href: 'https://bh.wingie.com/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://bh.wingie.com/ja/awards/' },
      ],
    },
  ],
  'bh-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://bh.wingie.com/zh/contact/' },
        { title: '常见问题', href: 'https://bh.wingie.com/en/faq/' },
        { title: '关于我们', href: 'https://bh.wingie.com/zh/about-us/' },
        { title: '隐私政策', href: 'https://bh.wingie.com/zh/privacy/' },
        { title: '条款和条件', href: 'https://bh.wingie.com/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://bh.wingie.com/zh/awards/' },
      ],
    },
  ],
  'bh-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://bh.wingie.com/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://bh.wingie.com/en/faq/' },
        { title: '회사 소개', href: 'https://bh.wingie.com/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://bh.wingie.com/ko/privacy/' },
        { title: '이용약관', href: 'https://bh.wingie.com/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://bh.wingie.com/ko/awards/' },
      ],
    },
  ],
  'bh-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://bh.wingie.com/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://bh.wingie.com/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://bh.wingie.com/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://bh.wingie.com/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://bh.wingie.com/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://bh.wingie.com/hi/awards/' },
      ],
    },
  ],
  'bh-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://bh.wingie.com/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://bh.wingie.com/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://bh.wingie.com/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://bh.wingie.com/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://bh.wingie.com/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://bh.wingie.com/ta/awards/' },
      ],
    },
  ],
  'bh-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://bh.wingie.com/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://bh.wingie.com/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://bh.wingie.com/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://bh.wingie.com/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://bh.wingie.com/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://bh.wingie.com/th/awards/' },
      ],
    },
  ],
  'bh-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://bh.wingie.com/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://bh.wingie.com/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://bh.wingie.com/ur/about-us/' },
        { title: 'رازداری', href: 'https://bh.wingie.com/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://bh.wingie.com/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://bh.wingie.com/ur/awards/' },
      ],
    },
  ],
  'bh-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://bh.wingie.com/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://bh.wingie.com/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://bh.wingie.com/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://bh.wingie.com/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://bh.wingie.com/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://bh.wingie.com/ka/awards/' },
      ],
    },
  ],
}
